export default {
	setScreenSize: state => {
		state.windowSize.width = window.innerWidth
		state.windowSize.height = window.innerHeight
	},
	setLocalStorage: (state, data) => {
		Object.keys(data).forEach(key => {
			localStorage[key] = data[key]
		})
	},
	setCustomer: (state, data) => {
		state.customer = data
		state.activeAccount = data
	},
	setShowIdUpdateModal: (state, value) => {
		state.showIdUpdateModal = value
	},
	setShowAnnouncement: (state, value) => {
		state.showAnnouncement = value
	},
	setActiveAccount: (state, account) => {
		state.activeAccount = account
	},
	setHasDirectDebit: (state, value) => {
		state.hasDirectDebit = value
	},
	setMomoAccount: (state, value) => state.momoAccount = value,
	setMomoAccounts: (state, data) => state.momoAccounts = data,
}
